// แบนเนอร์ดาวน์โหลด/สถานะโมเดลในเครื่อง
import React from "react";
import { UNSUPPORTED_MSG } from "../../services/ai/engine";
import { Button, Icon, ModelMark, Progress } from "../ui";

export default function ModelLoader({ model, ai, compact }) {
  if (!model || model.kind !== "local" || ai.isMock) return null;
  const { state, ready, cached, download, supported } = ai;
  const mine = state.status === "loading" && state.modelId === model.webllmId;
  const progress = mine ? state.progress : 0;
  if (ready) return null;
  if (!supported)
    return (
      <div className="loader-card is-warn">
        <Icon name="alert" size={20} />
        <div className="min0">
          <b>เบราว์เซอร์นี้รัน AI ในเครื่องไม่ได้</b>
          <div className="small muted">{UNSUPPORTED_MSG}</div>
        </div>
      </div>
    );
  const failed = state.status === "error" && state.modelId === model.webllmId;
  // ดาวน์โหลดอัตโนมัติเมื่อเข้าหน้า — แสดงแถบความคืบหน้าเสมอ ยกเว้นโหลดล้มเหลว (ให้กดลองใหม่)
  const loading = !failed;
  return (
    <div className={"loader-card" + (compact ? " is-compact" : "")}>
      <ModelMark model={model} size={36} />
      <div className="loader-body min0">
        {loading ? (
          <>
            <div className="loader-title">
              <b>กำลังเตรียม {model.name}</b>
              <span className="brand b">{Math.round(progress * 100)}%</span>
            </div>
            <Progress value={progress} height={7} />
            <div className="tiny faint ellipsis mt-4">{(mine && state.text) || (cached === false ? "กำลังดาวน์โหลดโมเดลครั้งแรก (ครั้งต่อไปเปิดจากแคช)..." : "กำลังโหลด...")}</div>
          </>
        ) : (
          <>
            <div className="loader-title">
              <b>เตรียม {model.name} ไม่สำเร็จ</b>
            </div>
            <div className="small danger mt-4">{state.error}</div>
          </>
        )}
      </div>
      {!loading ? (
        <Button variant="primary" size="sm" icon="download" onClick={download}>
          ลองใหม่
        </Button>
      ) : null}
    </div>
  );
}
